<template>
    <div class="form-group" :class="wrapperClass">
        <label :for="id.ID()" :class="{'sr-only': srOnly}">
            <slot name="label">{{ label + (error && errorMessage ? ` ${$t('dash-{s}', {'s': errorMessage})}` : '') }}</slot>
        </label>
        <input 
            :id="id.ID()"
            type="number"
            :value="value"
            @change="handleChange"
            class="form-control"
            :class="inputClass" 
            :min="min ? `${min}` : ''"
            :max="max ? `${max}` : ''"
            :disabled="disabled"
        />
    </div>
</template>

<script>
import id from "src/modules/uuid.js"

export default {
    props: {
        value: Number,
        label: {
            type: String,
            required: true,
        },
        srOnly: {
            type: Boolean,
            default: false,
        },
        error: {
            type: Boolean,
            default: false,
        },
        errorMessage: {
            type: String,
            default: '',
        },
        min: Number,
        max: Number,
        nullable: Boolean,
        nullLabel: {
            type: String,
            default: '',
        },
        disabled: Boolean,
        inputClass: { 
            type: String, 
            default: '' 
        },
        wrapperClass: { 
            type: String, 
            default: '' 
        }
    },
    data() {
        return {
            id: new id()
        }
    },
    methods: {
        handleChange(event) {
            if (this.nullable && !event.target.value) {
                this.$emit('input', null)
                return
            }

            let val = Number(event.target.value)

            if (!this.min && !this.max) this.$emit('input', val)

            if (this.min && val < this.min) val = this.min
            else if (this.max && val > this.max) val = this.max

            event.target.value = `${val}`
            this.$emit('input', val)
        }
    },
}
</script>